<div class="d-flex justify-content-between pt-4 cursor-pointer" (click)="dropInput.click()">
  <div class="d-flex align-items-center" *ngIf="config.withLogo">
    <div class="logo mr-8" [ngClass]="{ bg: !logoUrl }">
      <img *ngIf="logoUrl" [src]="logoUrl | safeUrl" alt="logo" />
    </div>
  </div>
  <div
    class="text w-full"
    [class.b-greyscale-700]="(_currentThemeSubject | async) === 'dark'"
    [class.b-light-stroke]="(_currentThemeSubject | async) === 'light'"
    fbDragDropFile
    matRipple
    (fileDropped)="addFile($event)"
  >
    <input
      hidden
      type="file"
      #dropInput
      name="file"
      [accept]="config.availableFileTypes || defaultFileTypes"
      (change)="addFile($event.target.files)"
      (click)="dropInput.value = null"
    />
    <ng-container *ngIf="!file?.name">
      <span class="click-btn">{{ config.ctaText ? config.ctaText : ('Click to upload' | translate | async) }} </span>
      {{ 'or drag and drop' | translate | async }}
      <span class="text-1">
        <bdi>PDF, SVG, PNG, JPG {{ 'or' | translate | async }} GIF </bdi>
        <bdo dir="ltr">(max. 800x400px)</bdo>
      </span>
    </ng-container>
    <ng-container *ngIf="file?.name">
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-direction-column">
          <span
            class="t-footnote-semibold text-align-start"
            [class.dark-theme-color]="(_currentThemeSubject | async) === 'dark'"
            [class.light-theme-color]="(_currentThemeSubject | async) === 'light'"
            >{{ file.name }}</span
          >
          <span
            class="t-caption-regular mt-8"
            [class.dark-theme-color]="(_currentThemeSubject | async) === 'dark'"
            [class.light-theme-color]="(_currentThemeSubject | async) === 'light'"
            >Date added: {{ date }}</span
          >
        </div>

        <button
          class="t-footnote-medium border-radius-8 py-8 px-44 c-pointer"
          [class.dark-theme-bg-color]="(_currentThemeSubject | async) === 'dark'"
          [class.light-theme-bg-color]="(_currentThemeSubject | async) === 'light'"
          [class.b-greyscale-700]="(_currentThemeSubject | async) === 'dark'"
          [class.b-light-stroke]="(_currentThemeSubject | async) === 'light'"
        >
          Change
        </button>
      </div>
    </ng-container>
  </div>
</div>
